<template>
  <transition
	  name="custom"
	  v-bind:enter-active-class="fadeIn"
	  v-bind:leave-active-class="fadeOut"
	>
	  <div v-if="loading || identifierLoading" v-bind:class="{ loadContainer: true, inline: inline }">
	  	<div v-if="identifier && identifierLoading" :class="'loader ' + classes "> <i class="fa fa-circle-o-notch fa-spin"></i> </div>
	  	<div v-if="loading" :class="'loader ' + classes "> <i class="fa fa-circle-o-notch fa-spin"></i> </div>
	  </div>
   </transition>
</template>

<script>
 
export default {
  data: function(){ 
    return{

    }
  },

  props: ['identifier', 'loading', 'classes', 'inline', 'fadeIn', 'fadeOut'],

  computed: {

  	identifierLoading(){
  	  return this.$store.state.loading[this.identifier];
  	}

  },

}
</script>

<style>

.loadContainer{
	display: inline-block;
	width: 100%;

	&.inline{
		width: auto;
	}
}

.loader{

	display: inline-block;

	&.cover{
		width: 100%;
	    height: 100%;
	    position: absolute;
	    top: 0;
	    left: 0;
	    text-align: center;
	    font-size: 30px;
	    color: #414141;

	    i{
		    font-size: 30px;
		    margin-top: 30%;

		     /* Mobile */
		    @media screen and (max-width: 812px) {
		    	margin-top: 36%;
		    }

	    }
	}

	&.dimmer{
		background: rgba(255, 255, 255, 0.45);
	}

}

</style>



// WEBPACK FOOTER //
// Loader.vue?cdcf2476